import axios from "axios";
import React, { Dispatch, SetStateAction } from 'react';
import { AnyIfEmpty } from "react-redux";
import { GET_EVENTS_LOCKER_LIST_FAILURE, GET_EVENTS_LOCKER_LIST_REQUEST, GET_EVENTS_LOCKER_LIST_SUCCESS, RESET_EVENTS_LOCKER_LIST_STATE } from "../constants/eventsLockerList.constants";

export interface EventsLockerListParams {
    locationId: string;
    startDate: string;
    endDate: string;
    startTime: string;
    endTime: string;
    propertyEventId?: string;
}

const getEventsLockerListRequest = () => {
    return {
        type: GET_EVENTS_LOCKER_LIST_REQUEST,
    };
};

const getEventsLockerListSuccess = (lockerData: AnyIfEmpty<object>) => {
    return {
        type: GET_EVENTS_LOCKER_LIST_SUCCESS,
        payload: lockerData,
    };
};

const getEventsLockerListFailure = (lockerError: string) => {
    return {
        type: GET_EVENTS_LOCKER_LIST_FAILURE,
        payload: lockerError,
    };
};

export const resetEventsLockerListState = () => {
    return {
        type: RESET_EVENTS_LOCKER_LIST_STATE,
    };
};

export const getEventsLockerList =
    (params: EventsLockerListParams) =>
        async (dispatch: Dispatch<any>) => {
            dispatch(getEventsLockerListRequest());
            try {
                const response = await axios.get(`/property-events/availableLockers`, { params });
                if (response?.data?.available && response?.data?.lockers) {
                    dispatch(getEventsLockerListSuccess(response.data?.lockers))
                } else {
                    dispatch(getEventsLockerListFailure(response.data.message))
                }
            } catch (error: any) {
                dispatch(getEventsLockerListFailure(error.response?.data?.message || "Something went wrong"));
            }
        };
